import { FaTrash } from "react-icons/fa";
import React, { useState } from "react";
import ConfirmationModal from "./ConfirmationModal";

function DeleteButton({ onConfirm, errorMessage, setErrorMessage }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {isModalOpen && (
        <ConfirmationModal
          onClose={() => setIsModalOpen(false)}
          onConfirm={onConfirm}
          errorMessage={errorMessage}
        />
      )}
      <button
        onClick={() => {
          setIsModalOpen(true);
          if (setErrorMessage) setErrorMessage("");
        }}
      >
        <FaTrash className="text-red-500" />
      </button>
    </>
  );
}

export default DeleteButton;
